export default __webpack_public_path__ + "static/media/Mark-6-Suit-03.9c5fd3ab.jpg";